/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/display-name */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-key */
import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  UncontrolledDropdown,
} from "reactstrap"; //
import AppLayout from "layout/AppLayout";
import axios from "axiosClient";
import { useToken } from "auth/useToken";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { useUser } from "auth/useUser";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ListingTable2 from "components/ListingTable2";
import { toast } from "react-toastify";
import LoadError from "components/LoadError";

const customCols = [
  {
    Header: "Passport No",
    accessor: "document",
    cellClass: "text-muted w-10",
    Cell: (props) => <>{props.value}</>,
    sortType: "basic",
  },
  {
    Header: "PINPP",
    accessor: "pinpp",
    cellClass: "text-muted w-10",
    Cell: (props) => <>{props.value}</>,
    sortType: "basic",
  },
  {
    Header: "Candidate",
    accessor: "candidateName",
    cellClass: "text-muted w-20",
    Cell: (props) => (
      <>
        {/* <NavLink to={`/app/payments/enquiry/${props.row.original._id}`}> */}
        {`${props.row.original.namelatin} ${props.row.original.surnamelatin}`}
        {/* </NavLink> */}
      </>
    ),
    sortType: "basic",
  },
  {
    Header: "Date of Birth",
    accessor: "birth_date",
    cellClass: "text-muted w-10",
    Cell: (props) => (
      <>{moment(props.value, "YYYY-MM-DD").format("DD/MM/YYYY")}</>
    ),
    sortType: "basic",
  },
  {
    Header: "Created At",
    accessor: "createdAt",
    cellClass: "text-muted w-10",
    Cell: (props) => <>{moment(props.value).format("DD/MM/YYYY")}</>,
    sortType: "basic",
  },
];

const PinsList = () => {
  const user = useUser();
  const cols = React.useMemo(() => [...customCols], []);

  const [token, setToken] = useToken();
  const [itemsList, setItemsList] = useState([]);
  const [itemsTotal, setItemsTotal] = useState(0);
  const [searchValues, setSearchValues] = useState({});
  const [showData, setShowData] = useState(false);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [selectedPageSize, setSelectedPageSize] = useState(30);
  const [loadError, setLoadError] = useState("");

  const [isUser, setIsUser] = useState(
    user.role === "User" ? true : user.role === "Consultant" ? true : false
  );

  useEffect(() => {
    let isMounted = true;
    handleSearchSubmit(1, selectedPageSize, searchValues);
    return () => {
      isMounted = false;
    };
  }, []);

  const handleSearchValueChange = (e) => {
    setSearchValues({ ...searchValues, [e.target.name]: e.target.value });
  };

  const handleSearchSubmit = (
    currentPage = 1,
    selectedPageSize = 30,
    searchValues
  ) => {
    setLoading(true);
    setLoadError("");
    axios
      .post(
        "/api/pins-list",
        { page: currentPage, per_page: selectedPageSize, ...searchValues },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((result) => {
        setItemsList(result.data.items);
        setItemsTotal(result.data.total);
        setShowData(true);
        setCurrentPage(result.data.page);
        setTotalPage(result.data.pageCount);
      })
      .catch(() => {
        const message =
          "Could not load the PINFL list. Check your connection and try again.";
        setLoadError(message);
        toast.error(message);
      })
      .finally(() => setLoading(false));
  };

  const handleDownload = () => {
    axios
      .post("/api/pins-download", searchValues, {
        responseType: "blob",
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((result) => {
        // FileDownload(result.data, "enquiries.xlsx");
        // window.saveAs(new Blob([result.data]), "enquiries.xlsx");
        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement("a");
        link.href = url;
        link.download = "pinfl.xlsx"; //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  };

  return (
    <AppLayout>
      <div className="dashboard-wrapper">
        <Card className="h-100 m-4">
          <CardBody>
            <CardTitle>PINFL List</CardTitle>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                handleSearchSubmit(1, selectedPageSize, searchValues);
              }}
            >
              <Row className="text-left">
                <Col md="3">
                  <FormGroup>
                    <Label>PINFL</Label>
                    <Input
                      type="text"
                      name="pinpp"
                      value={searchValues.pinpp}
                      onChange={handleSearchValueChange}
                    />
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <Label>First Name</Label>
                    <Input
                      type="text"
                      name="namelatin"
                      value={searchValues.namelatin}
                      onChange={handleSearchValueChange}
                    />
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <Label>Last Name</Label>
                    <Input
                      type="text"
                      name="surnamelatin"
                      value={searchValues.surnamelatin}
                      onChange={handleSearchValueChange}
                    />
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <Label>Passport</Label>
                    <Input
                      type="text"
                      name="document"
                      value={searchValues.document}
                      onChange={handleSearchValueChange}
                    />
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <Label>From</Label>
                    <DatePicker
                      name="from"
                      autoComplete="off"
                      selected={
                        searchValues.from ? new Date(searchValues.from) : null
                      }
                      dateFormat="dd/MM/yyyy"
                      placeholderText="dd/mm/yyyy"
                      onChange={(date) => {
                        setSearchValues({
                          ...searchValues,
                          from: moment(date).format("YYYY-MM-DD"),
                        });
                      }}
                    />
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <Label>To</Label>
                    <DatePicker
                      name="to"
                      autoComplete="off"
                      selected={
                        searchValues.to ? new Date(searchValues.to) : null
                      }
                      dateFormat="dd/MM/yyyy"
                      placeholderText="dd/mm/yyyy"
                      onChange={(date) => {
                        setSearchValues({
                          ...searchValues,
                          to: moment(date).format("YYYY-MM-DD"),
                        });
                      }}
                    />
                  </FormGroup>
                </Col>
                <Col md="12" className="d-flex justify-content-between">
                  <UncontrolledDropdown>
                    <DropdownToggle caret color="light" className="mr-2">
                      Actions
                    </DropdownToggle>
                    <DropdownMenu>
                      {!isUser && (
                        <DropdownItem onClick={handleDownload}>
                          Download .xlsx
                        </DropdownItem>
                      )}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                  <Button
                    color="primary"
                    onClick={() =>
                      handleSearchSubmit(1, selectedPageSize, searchValues)
                    }
                    className="mr-2"
                    disabled={loading}
                  >
                    {loading ? "Searching…" : "Search"}
                  </Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
        {!showData && loadError && (
          <LoadError
            className="mx-4"
            message={loadError}
            onRetry={() =>
              handleSearchSubmit(1, selectedPageSize, searchValues)
            }
            busy={loading}
          />
        )}
        {showData && (
          <ListingTable2
            columns={cols}
            data={itemsList}
            totalItemCount={itemsTotal}
            handleSearch={handleSearchSubmit}
            loading={loading}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPage={totalPage}
            selectedPageSize={selectedPageSize}
            setSelectedPageSize={setSelectedPageSize}
            searchValues={searchValues}
            withNumeration={false}
            error={loadError}
            onRetry={() =>
              handleSearchSubmit(currentPage, selectedPageSize, searchValues)
            }
          />
        )}
      </div>
    </AppLayout>
  );
};

export default PinsList;
